
export const FormValidation = {
	async validateForm(formData, formElement, getFormDataFn) {
		const { state, callbacks, config } = formData;
		const data = getFormDataFn();
		state.errors = {};
		const validationResults = await Promise.all(
			callbacks.onValidate.map(cb => safeCall(cb, { formId: formElement.attr('id'), data }))
		);
		const hasErrors = validationResults.some(r => r && r.errors);
		if (hasErrors) {
			validationResults.forEach(r => { if (r && r.errors) Object.assign(state.errors, r.errors); });
		}
		const isHTML5Valid = formElement[0].checkValidity();
		state.isValid = !hasErrors && isHTML5Valid;
		return state.isValid;
	},

	async validateField(formData, formElement, fieldName) {
		const { state } = formData;
		const fieldElement = formElement.find(`[name="${fieldName}"]`);
		if (fieldElement.length === 0) return false;
		const isHTML5Valid = fieldElement[0].checkValidity();
		if (!isHTML5Valid) {
			state.errors[fieldName] = fieldElement[0].validationMessage;
			return false;
		}
		delete state.errors[fieldName];
		state.isValid = Object.keys(state.errors).length === 0;
		return true;
	}
};

async function safeCall(cb, params){
	try{ return await cb(params); } catch(_){ return false; }
}


